module.exports = __webpack_public_path__ + "img/ticket_ex3.f1cb50a3.svg";